import React from "react";

export function Logo({ className = "" }) {
  return (
    <img
      src="/jetseat-logo.png"
      alt="JetSeat"
      className={`h-7 w-auto select-none ${className}`}
      data-testid="jetseat-logo"
      draggable="false"
    />
  );
}
